import './Error.less';
import { globalActions } from '@redux/slices/global';
import { IRootSlice } from '@typings/rootSlice';
import React, { useEffect, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import errorContent from './ErrorContent';

const Error: FC = () => {
    const dispatch = useDispatch();
    const errorCode = useSelector((state: IRootSlice) => state.globalSlice.error.code);
    const config = errorContent[`error${errorCode}`];
    const { imgSrc, imgSet, title, getContent } = config || {};
    const clearError = () => dispatch(globalActions.clearError());

    useEffect(
        () => () => {
            clearError();
        },
        [],
    );

    if (!config) return null;

    return (
        <div className="error__container">
            <img alt={`Error: ${errorCode}`} src={imgSrc} srcSet={imgSet} />
            <div className="error__text">
                <h2>{title}</h2>
                {getContent()}
            </div>
        </div>
    );
};

export default Error;
